// Routed by the platform reverse proxy: /api/session -> access-session-service.
const APP_SESSION_BASE = '/api/session/v3/app-session';

export const APP_SESSION_ENDPOINTS = {
  get: APP_SESSION_BASE,
  create: APP_SESSION_BASE,
  extend: `${APP_SESSION_BASE}/extend`,
  logout: `${APP_SESSION_BASE}/logout`,
} as const;
